import React, { useEffect, useState } from "react";
import { FaRegEdit, FaRegEye } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { FormControl } from "@material-ui/core";
import TableHeader from "../../../../components/Table/TableHeader";
import TablePagination from "../../../../components/Table/TablePagination";
import InputSearch from "../../../../components/InputSearch";
import ResumoOportunidade from "../ResumoOportunidade";
import "../styles.scss";
import globals from "../../../../globals";
const LINK_PORTAL = globals.REACT_APP_URL_BASE_FRONT_PORTAL;

const ListOportunidade = ({ response, buscar, busca, mudarPagina }) => {
  const history = useHistory();
  const [modalData, setModalData] = useState({
    showModal: false,
  });
  const [novaLista, setNovaLista] = useState([]);
  const [sortConfig, setSortConfig] = useState(null);
  const changePage = (page) => {
    mudarPagina(page);
  };

  const gotoDet = (data) => {
    setModalData({
      showModal: true,
      ...data,
    });
  };

  const redirectDeal = (id) => {
    history.push(`/oportunidade/editar/${id}`);
  };

  const formatarData = (value) => {
    const data = new Date(value);

    return `${data.toLocaleDateString()}`;
  };

  const handleCloseModal = () => {
    setModalData({ showModal: false });
  };

  // Colunas da tabela
  const tabelaColunas = ["ID", "Data de criação", "Seller CNPJ", "Razão Social", "Motivo Oferta", "TP", "Status", "Ações"];
  const sortableColumns = [0, 1, 2, 3, 4, 5, 6]; // Todas exceto Ações

  // Função de ordenação
  const handleSort = (columnIndex) => {
    let direction = 'asc';
    if (sortConfig?.columnIndex === columnIndex && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ columnIndex, direction });
  };

  // Função para obter lista ordenada
  const getSortedList = () => {
    if (!novaLista || !sortConfig) {
      return novaLista || [];
    }

    const sorted = [...novaLista].sort((a, b) => {
      let valueA, valueB;

      switch (sortConfig.columnIndex) {
        case 0: // ID
          valueA = a.codigo;
          valueB = b.codigo;
          break;
        case 1: // Data de criação
          valueA = new Date(a.dataHora).getTime();
          valueB = new Date(b.dataHora).getTime();
          break;
        case 2: // Seller CNPJ
          valueA = (a.sellerCNPJ || '').toLowerCase();
          valueB = (b.sellerCNPJ || '').toLowerCase();
          break;
        case 3: // Razão Social
          valueA = (a.seller || '').toLowerCase();
          valueB = (b.seller || '').toLowerCase();
          break;
        case 4: // Motivo Oferta
          valueA = (a.motivoOfertaDescricao || '').toLowerCase();
          valueB = (b.motivoOfertaDescricao || '').toLowerCase();
          break;
        case 5: // TP
          valueA = a.tp;
          valueB = b.tp;
          break;
        case 6: // Status
          valueA = (a.status || '').toLowerCase();
          valueB = (b.status || '').toLowerCase();
          break;
        default:
          return 0;
      }

      if (valueA < valueB) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (valueA > valueB) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });

    return sorted;
  };

  useEffect(() => {
    setNovaLista(response?.lista);
    console.log(novaLista);
  }, [response]);

  return (
    <div>
      <div className="row justify-content-end">
        <div className="col-md-3 mt-3">
          <FormControl>
            <InputSearch buscar={buscar} buscaPor={busca} />
          </FormControl>
        </div>
      </div>

      <div className="row">
        <div className="col-12 mt20">
          <div className="table-responsive produtos-lista">
            <table className="table table-sm table-striped">
              <TableHeader
                columns={tabelaColunas}
                onSort={handleSort}
                sortConfig={sortConfig}
                sortableColumns={sortableColumns}
              />

              <tbody>
                {(!novaLista || novaLista?.length === 0) && (
                  <tr>
                    <td colSpan={8}> Sem Registros </td>
                  </tr>
                )}
                {getSortedList()?.map((data, i) => (
                    <tr key={data.id}>
                      <td> {data.codigo.toString().padStart(6, "0")} </td>
                      <td> {formatarData(data.dataHora)} </td>
                      <td> {data.sellerCNPJ} </td>
                      <td> {data.seller} </td>
                      <td>{data.motivoOfertaDescricao}</td>
                      <td> {data.tp} </td>
                      <td> {data.status} </td>
                      <td className="text-right">
                        <div className="row justify-content-center align-items-center">
                          <div>
                            <FaRegEdit
                              style={{
                                marginRight: "10px",
                                cursor: "pointer",
                                fontSize: 18,
                              }}
                              onClick={() =>
                                history.push(`/oportunidade/editar/${data.id}`)
                              }
                            />
                          </div>
                          <div>
                            <FaRegEye
                              style={{
                                marginRight: "10px",
                                cursor: "pointer",
                                fontSize: 18,
                              }}
                              onClick={() =>
                                window.open(
                                  LINK_PORTAL + "/pedido/" + data.codigo,
                                  "_blank"
                                )
                              }
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <TablePagination data={response} changePage={changePage} />
          </div>
        </div>
      </div>

      {modalData.showModal && (
        <ResumoOportunidade
          showModal={modalData.showModal}
          handleCloseModal={handleCloseModal}
          data={modalData}
        />
      )}
    </div>
  );
};

export default ListOportunidade;
